// based on: https://github.com/vtaits/react-select-async-paginate/tree/master/packages/react-select-async-paginate
//import Select from 'react-select';
import { withAsyncPaginate } from './withAsyncPaginate';

import { Select } from 'ui/components/styled';

export const AsyncPaginate = withAsyncPaginate(Select);
